module.exports = __webpack_public_path__ + "static/media/logoBlue.e69771b9.png";